import VueRouter from "vue-router";
import { EventBus } from "../event-bus.js";
import { setCookie } from "../utils/cookie.js";
import store from "@/store";
import MainLayout from "@/layouts/MainLayout.vue";
const EmptyRouterView = { render: (h) => h("router-view") };

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/Login.vue"),
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("@/pages/Signup.vue"),
  },
  {
    path: "/requestResetPassword",
    name: "requestResetPassword",
    component: () => import("@/pages/RequestResetPassword.vue"),
  },
  {
    path: "/requestResetPassword",
    name: "resetPassword",
    component: () => import("@/pages/ResetPassword.vue"),
  },
  {
    path: "/notification-feedback",
    name: "notification-feedback",
    component: () => import("@/pages/whats-app/AlertDetailFromWhatsApp.vue"),
  },
  {
    path: "/notification-resume",
    name: "notification-resume",
    component: () => import("@/pages/whats-app-v2/ResumedAlertDetails.vue"),
  },
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "home",
        redirect: { name: "dashboard" }, // 默认重定向到 dashboard
      },
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("@/pages/dashboard/DashboardPage.vue"),
      },
      {
        path: "devices",
        name: "devices",
        component: () => import("@/pages/devices/DevicesPage.vue"),
      },
      {
        path: "map",
        name: "map",
        component: () => import("@/components/Map.vue"),
      },
      {
        path: "connect",
        name: "connect",
        component: () => import("@/components/Connect.vue"),
      },
      {
        path: "ai",
        name: "ai",
        component: () => import("@/components/AI.vue"),
      },
      {
        path: "ai-agents",
        name: "ai-agents",
        component: () => import("@/pages/ai-agent/AiAgentListPage.vue"),
      },
      {
        path: "shadow",
        name: "shadow",
        component: () => import("@/components/Shadow.vue"),
      },
      {
        path: "app",
        name: "app",
        component: () => import("@/components/app/AppListPage.vue"),
      },
      {
        path: "flow/:id?",
        name: "flow-detail",
        component: () => import("@/components/Flow.vue"),
        props: (route) => ({ id: route.params.id }),
      },
      {
        path: "ruleflow",
        name: "ruleflow-list",
        component: () => import("@/components/rulego/RuleGoList.vue"),
      },
      {
        path: "ruleflow-new",
        name: "ruleflow-new",
        component: () => import("@/components/rulego/RuleGoEditor.vue"),
      },
      {
        path: "ruleflow/:id",
        name: "ruleflow-edit",
        component: () => import("@/components/rulego/RuleGoEditor.vue"),
        props: true,
      },
      {
        path: "ai-audit-logs",
        name: "ai-audit-logs",
        component: () => import("@/pages/ai-agent/audit-logs/AiAuditLogs.vue"),
      },
      {
        path: "settings",
        component: EmptyRouterView,
        children: [
          {
            path: "",
            name: "settings",
            component: () => import("@/pages/Setting.vue"),
          },
          {
            path: "users",
            name: "users",
            component: () => import("@/components/user/UserPage.vue"),
          },
          {
            path: "whats-app-alerts",
            name: "whats-app-alerts",
            component: () => import("@/pages/whats-app/WhatsAppAlertsPage.vue"),
          },
          {
            path: "whats-app-alerts-v2",
            name: "whats-app-alerts-v2",
            component: () => import("@/pages/whats-app-v2/WhatsAppAlertsPage.vue"),
          },
          {
            path: "digital-displays",
            name: "digital-displays",
            component: () =>
              import("@/pages/digital-displays/DigitalDisplaysPage.vue"),
          },
        ],
      },
      {
        path: "demo",
        component: EmptyRouterView,
        children: [
          {
            path: "",
            redirect: { name: "demo-open" },
          },
          {
            path: "open",
            name: "demo-open",
            component: () => import("@/pages/demo/OpenWindowPage.vue"),
          },
          {
            path: "theme",
            name: "demo-theme",
            component: () => import("@/pages/demo/ThemePage.vue"),
          },
          {
            path: "tailwindcss",
            name: "demo-tailwindcss",
            component: () => import("@/pages/demo/TailwindCSSPage.vue"),
          },
          {
            path: "smart-checkbox",
            name: "demo-smart-checkbox",
            component: () => import("@/pages/demo/SmartCheckboxGroupPage.vue"),
          },
          {
            path: "smart-select",
            name: "demo-smart-select",
            component: () => import("@/pages/demo/SmartSelectPage.vue"),
          },
          {
            path: "upload-file",
            name: "demo-upload-file",
            component: () => import("@/pages/demo/UploadFilePage.vue"),
          },
          {
            path: "demo-progress",
            name: "demo-progress",
            component: () => import("@/pages/demo/DemoProgress.vue"),
          },
          {
            path: "table-theme",
            name: "demo-table-theme",
            component: () => import("@/pages/demo/DemoTableTheme.vue"),
          },
          {
            path: "smart-date-picker",
            name: "SmartDatePickerDemo",
            component: () => import("@/pages/demo/SmartDatePickerDemo.vue"),
          },
          {
            path: "demo-date-range-panel",
            name: "demo-date-range-panel",
            component: () => import("@/pages/demo/DemoDateRangePanel.vue"),
          },
          {
            path: "demo-infinite-scroll",
            name: "demo-infinite-scroll",
            component: () => import("@/pages/demo/DemoInfiniteScroll.vue"),
          },
          {
            path: "demo-debounce",
            name: "demo-debounce",
            component: () => import("@/pages/demo/DemoDebounce.vue"),
          },
          {
            path: "demo-custom-dialog",
            name: "demo-custom-dialog",
            component: () => import("@/pages/demo/DemoCustomDialog.vue"),
          },
          {
            path: "demo-date-picker",
            name: "demo-date-picker",
            component: () => import("@/pages/demo/DemoDatePicker.vue"),
          },
          {
            path: "smart-infinite-cursor-scroll",
            name: "demo-smart-infinite-cursor-scroll",
            component: () => import("@/pages/whats-app-v2/SmartInfiniteCursorScrollDemo.vue"),
          },
        ],
      },
    ],
  },
  {
    //404
    path: "*",
    name: "not-found",
    component: () => import("@/pages/NotFound.vue"),
  },
];

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
  mode: "hash",
  routes: routes, // (缩写) 相当于 routes: routes
});

// 白名单页面名称
const whiteList = [
  "login",
  "signup",
  "requestResetPassword",
  "resetPassword",
  "notification-feedback",
  "notification-resume",
];

// permission control
router.beforeEach(async (to, from, next) => {
  const queryToken = to?.query?.token;
  if (queryToken) {
    localStorage.setItem("token", queryToken);
  }

  const isAuthenticated = localStorage.getItem("token");

  // 如果localStorage中有token，就说明已经登录。获取全局状态中用户信息
  if (
    !whiteList.includes(to.name) && //白名单不获取用户信息
    isAuthenticated &&
    store.state.user === null &&
    store.state.loadingUser === false
  ) {
    await store.dispatch("getUserInfo");
  }

  // 登录后自动跳转redirect参数
  if (to.name === "login" && isAuthenticated && to.query.redirect) {
    next(decodeURIComponent(to.query.redirect));
    return;
  }

  if (isAuthenticated) {
    next();
  } else if (whiteList.indexOf(to.name) > -1) {
    next();
  } else {
    // 未登录，跳转到登录页并带redirect参数
    next({
      name: "login",
      query: { redirect: encodeURIComponent(to.fullPath) },
    });
  }
});

EventBus.$on("logout", () => {
  // 进入登录页面
  setCookie("access-token", "/", ".cereb.ai");
  localStorage.removeItem("token");
  if (router.currentRoute.name !== "login") {
    router.go({
      name: "login",
    });
  }
});

export default router;
